angular.module('tuitionFeesModule')
    .component('invoiceDetailViewAddCreditNote', {
        bindings: {
            invoiceId: '<',
            outstandingBalance: '<',
            maximumCredit: '<',
            fncSuccessAction: '<',
            paymentMethods: '<'
        },
        templateUrl: '/Scripts/app/tuitionFees/components/invoice/invoice-detail-view-add-credit-note.template.html',
        controller: class InvoiceDetailViewAddCreditNoteCtrl {
            // Bindings
            invoiceId: number;
            outstandingBalance: string;
            maximumCredit: string;
            fncSuccessAction: any;
            paymentMethods: any[];

            // Dependencies
            $timeout: any;
            invoiceService: any;

            // Variables
            isSubmitted: boolean;
            dateIssued: Date;
            amount: string; // number not working with sb-currency-input at moment.
            reference: string;

            static $inject = ['$timeout', 'invoiceService'];

            constructor($timeout, invoiceService) {
                this.$timeout = $timeout;
                this.invoiceService = invoiceService;

                this.isSubmitted = false;
            }

            $onInit(): void {
            }

            $onChanges(changes) {
                if (changes.invoiceId) {
                    this.resetFields();
                }

                if (changes.outstandingBalance)
                {
                    this.amount = this.outstandingBalance;
                }
            }

            resetFields() {
                this.amount = this.outstandingBalance;
                this.reference = '';
                this.dateIssued = moment.utc().startOf('day').toDate();
            }

            resetSubmit() {
                this.$timeout(function () {
                    this.isSubmitted = false;
                }.bind(this), 100);
            }

            addPayment() {

                this.isSubmitted = true;

                let payload = {
                    dateIssued: this.dateIssued,
                    amount: parseFloat(this.amount),
                    reference: this.reference
                };

                this.invoiceService.addCreditNote(this.invoiceId, payload).then(res => {
                    if (res?.isSuccess && this.fncSuccessAction) {
                        this.$timeout(function () {
                            this.resetFields();
                            this.fncSuccessAction(this.invoiceId);
                        }.bind(this), 100);
                    }

                    this.resetSubmit();
                });
            }
        }
    });
